const tableControlFilterHandler = {
  setFilter: ({ filter }, props) => (key, value) => {
    if (!filter[key]) {
      filter[key] = null
    }
    filter[key] = value

    if (props.onFilter) {
      props.onFilter(filter)
    }

    return filter
  }
}

export default tableControlFilterHandler
